import MECHANIX_EXT_1 from "./MECHANIX_EXT_1";

export default {
  MECHANIX_EXT_1,
};
